import axios from 'axios';
import { toast } from 'react-toastify';
import { config } from '../../../../config/envs';

const ADMIN_BASE_URL = config.app.adminBaseUrl;

export class CouponsAPI {
  static async list({ page = 0, limit = 10, code, active } = {}) {
    try {
      const params = new URLSearchParams();
      if (code) params.append('code', code);
      if (active !== undefined) params.append('active', active);
      params.append('page', page);
      params.append('limit', limit);

      const response = await axios.get(
        `${ADMIN_BASE_URL}/v2/coupons?${params.toString()}`,
      );
      return response;
    } catch (error) {
      toast.error('Não foi possível carregar os cupons');
      throw error;
    }
  }

  static async get(id) {
    try {
      const response = await axios.get(`${ADMIN_BASE_URL}/v2/coupons/${id}`);
      return response;
    } catch (error) {
      toast.error('Não foi possível carregar o cupom');
      throw error;
    }
  }

  static async create({
    code,
    externalId,
    active,
    cyclesCount,
    expiresAt,
    startsAt,
    description,
  } = {}) {
    try {
      const response = await axios.post(`${ADMIN_BASE_URL}/v2/coupons`, {
        code,
        externalId,
        active,
        cyclesCount,
        startDate: startsAt,
        description,
        expiresAt,
      });
      return response;
    } catch (error) {
      toast.error('Não foi possível criar o cupom');
      throw error;
    }
  }

  static async update(
    id,
    { code, externalId, active, cyclesCount, expiresAt } = {},
  ) {
    try {
      const response = await axios.put(`${ADMIN_BASE_URL}/v2/coupons/${id}`, {
        code,
        externalId,
        active,
        cyclesCount,
        expiresAt,
      });
      return response;
    } catch (error) {
      toast.error('Não foi possível editar o cupom');
      throw error;
    }
  }

  static async delete(id) {
    try {
      const response = await axios.delete(`${ADMIN_BASE_URL}/v2/coupons/${id}`);
      return response;
    } catch (error) {
      toast.error('Não foi possível deletar o cupom');
      throw error;
    }
  }

  static async createRule(couponId, { valueType, value, scope, planId, addonId }) {
    try {
      const response = await axios.post(
        `${ADMIN_BASE_URL}/v2/coupons/${couponId}/rules`,
        { valueType, value, scope, planId, addonId },
      );
      return response;
    } catch (error) {
      toast.error('Não foi possível criar desconto no cupom');
      throw error;
    }
  }

  static async updateRule(
    couponId,
    ruleId,
    { valueType, value, scope, planId, addonId },
  ) {
    try {
      const response = await axios.put(
        `${ADMIN_BASE_URL}/v2/coupons/${couponId}/rules/${ruleId}`,
        { valueType, value, scope, planId, addonId },
      );
      return response;
    } catch (error) {
      toast.error('Não foi possível atualizar o desconto no cupom');
      throw error;
    }
  }

  static async deleteRule(couponId, ruleId) {
    try {
      const response = await axios.delete(
        `${ADMIN_BASE_URL}/v2/coupons/${couponId}/rules/${ruleId}`,
      );
      return response;
    } catch (error) {
      toast.error('Não foi possível deletar o desconto no cupom');
      throw error;
    }
  }
}
